import React, { Fragment } from "react";
import { Button, Modal } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { connect, ConnectedProps } from "react-redux";
import { layoutActions } from "store/layout";
import { RootState } from "store";

const mapStateToProps = (state: RootState) => ({
    isOpen: state.layoutSlice.isErrorModalOpen,
    errorMessage: state.layoutSlice.errorModalMessage,
    detailMessage: state.layoutSlice.errorModalDetailMessage,
});

const mapDispatchToProps = {
    close: layoutActions.closeErrorModal,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

const ErrorModal: React.FC<ConnectedProps<typeof connector>> = ({ isOpen, errorMessage, detailMessage, close }) => {
    const onClose = () => close();

    return (
        <Fragment>
            <Modal zIndex={2000} centered isOpen={isOpen} toggle={onClose}>
                <div className="text-center p-5">
                    <div className="avatar-icon-wrapper rounded-circle m-0">
                        <div className="d-inline-flex justify-content-center p-0 rounded-circle avatar-icon-wrapper bg-neutral-danger text-danger m-0 d-130">
                            <FontAwesomeIcon icon={faTimes} className="d-flex align-self-center display-3" />
                        </div>
                    </div>
                    <h4 className="font-weight-bold mt-4">{errorMessage}</h4>
                    {detailMessage && <p className="mb-0 font-size-lg text-muted">{detailMessage}</p>}
                    <div className="pt-4">
                        <Button onClick={onClose} color="neutral-secondary" className="btn-pill mx-1">
                            <span className="btn-wrapper--label">OK</span>
                        </Button>
                    </div>
                </div>
            </Modal>
        </Fragment>
    );
};

export default connector(ErrorModal);